import { render } from "./DatabaseVariables.vue?vue&type=template&id=690ce282"
import script from "./DatabaseVariables.vue?vue&type=script&lang=js"
export * from "./DatabaseVariables.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__